import React from 'react';
import './_footer.scss';
import LOGO from "../../static/logo-white.svg";

const Footer = () =>
  (<footer className="footer">
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <div className="footer-content">
          <p>
      Houston, TX 77077<br />
			Email: info@squidsource.com<br/><br/>
			<a href=" https://twitter.com/squidsource" target="_blank"><i className="fab fa-twitter fa-lg simple_social" ></i></a>&nbsp; &nbsp; &nbsp;
			
			<a href="https://www.facebook.com/squidsource" target="_blank"><i className="fab fa-facebook fa-lg simple_social" ></i></a>&nbsp; &nbsp; &nbsp;
			
			<a href="https://www.linkedin.com/company/squidsource" target="_blank"><i className="fab fa-linkedin fa-lg simple_social" ></i></a></p>
          </div>
        </div>
        <div className="col-lg-8 text-right">
        	<img src={LOGO} className="loguito-foot" />
        </div>
      </div>
    </div>
    <div className="suela">
    	<div className="container">
    		<div className="row">
    			<div className="col-12 text-center">
    				<p>&copy; Copyright Squidsource Interactive</p>
    			</div>
    		</div>
    	</div>
    </div>
  </footer>);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js